import { InvoiceConfig, ProjectCheckConfig } from '../types';

/**
 * Standardkonfiguration des Rechnungsmoduls.
 *
 * Gespeichert wird sie in profiles.settings.invoiceConfig. Bis dort etwas
 * hinterlegt ist, gelten diese Werte — mit einer Ausnahme, die bewusst LEER
 * bleibt: Steuernummer, USt-IdNr., Bankverbindung und Firmenangaben haben
 * keinen sinnvollen Standard. Ein geratener Platzhalter waere auf einer
 * festgeschriebenen Rechnung schlimmer als eine fehlende Angabe, denn die
 * Validierung faengt das Fehlen ab, einen falschen Wert aber nicht.
 */

export const DEFAULT_PROJECT_CHECK_CONFIG: ProjectCheckConfig = {
    enableReportCount: true,
    enableVorankHistory: true,
    enableContractOverrun: true,
    enableUnloggedQuantity: true,
    enableStartDocs: true,
    enableStalePositions: true,
    stalePositionMonths: 12,
    // Eine Abweichung von 1 ist haeufig der noch nicht archivierte laufende
    // Bericht; ab 2 stimmt etwas nicht.
    reportCountRedDelta: 2,
    blockOnRed: true,
};

export const DEFAULT_INVOICE_CONFIG: InvoiceConfig = {
    defaultTaxRateBp: 1900,
    defaultPaymentTermsDays: 14,
    defaultPaymentTerms:
        'Bitte überweisen Sie den Rechnungsbetrag ohne Abzug unter Angabe der Rechnungsnummer.',
    defaultIntroText: 'für die erbrachten Leistungen berechnen wir wie folgt:',
    numbering: {
        // Ein gemeinsamer Kreis über alle Belegarten — so vom Betreiber
        // entschieden. Auf getrennte Kreise umschaltbar, ohne Datenmigration.
        mode: 'shared',
        sharedSeries: 'RE',
        format: 'dash',
        padWidth: 4,
        withYear: true,
    },
    advanceDeductionMode: 'INDIVIDUAL',
    projectCheck: DEFAULT_PROJECT_CHECK_CONFIG,
    archiveYears: 8, // §147 AO
};

/**
 * Fuehrt gespeicherte Einstellungen mit den Standardwerten zusammen.
 *
 * Verschachtelte Objekte werden einzeln gemischt, damit eine unvollstaendig
 * gespeicherte Konfiguration (z.B. nur numbering.mode) nicht die uebrigen
 * Felder auf undefined setzt.
 */
export const resolveInvoiceConfig = (stored?: Partial<InvoiceConfig> | null): InvoiceConfig => ({
    ...DEFAULT_INVOICE_CONFIG,
    ...(stored ?? {}),
    numbering: { ...DEFAULT_INVOICE_CONFIG.numbering, ...(stored?.numbering ?? {}) },
    projectCheck: { ...DEFAULT_PROJECT_CHECK_CONFIG, ...(stored?.projectCheck ?? {}) },
    datev: stored?.datev,
});
